import React from "react";
import { LoadingProps } from "../../interfaces/connected-components/loading";
import { connect } from "react-redux";
import { RootState } from "../../redux/store";

/**
 * Loader component that displays a loading indicator.
 * @param {LoadingProps} loading - Loading state from Redux store.
 * @returns {JSX.Element} Loading indicator component.
 */
const Loader: React.FC<LoadingProps> = ({ loading }): JSX.Element | null => {
  const { isVisible } = loading || {};
  if (!isVisible) return null;
  return (
    <div className="fixed top-0 left-0 w-screen h-screen z-[999999] bg-black/30 backdrop-blur-sm flex justify-center items-center">
      <div className="relative w-11 h-11 animate-spinner-y0fdc1 [transform-style:preserve-3d]">
        <div className="absolute w-full h-full border-2 border-primary dark:border-white [transform:translateZ(-22px)_rotateY(180deg)]" />
        <div className="absolute w-full h-full border-2 border-primary dark:border-white [transform:rotateY(-270deg)_translateX(50%)] [transform-origin:top_right]" />
        <div className="absolute w-full h-full border-2 border-primary dark:border-white [transform:rotateY(270deg)_translateX(-50%)] [transform-origin:center_left]" />
        <div className="absolute w-full h-full border-2 border-primary dark:border-white [transform:rotateX(90deg)_translateY(-50%)] [transform-origin:top_center]" />
        <div className="absolute w-full h-full border-2 border-primary dark:border-white [transform:rotateX(-90deg)_translateY(50%)] [transform-origin:bottom_center]" />
        <div className="absolute w-full h-full border-2 border-primary dark:border-white [transform:translateZ(22px)]" />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loading: state.loading,
});

export default connect(mapStateToProps, null)(Loader);
